export const RepMetric = ({ icon: Icon, label, value, unit, bad, testId, color, fresh }) => (
  <div className={`rounded-2xl p-4 bg-white/[0.04] border ${bad ? "border-[#FF3B30]/50 bg-[#FF3B30]/[0.06]" : "border-white/[0.06]"}`} data-testid={testId}>
    <div className="flex items-center gap-2 text-[11px] text-neutral-400">
      <span className="w-6 h-6 rounded-full flex items-center justify-center" style={{ background: `${color}22`, color }}>
        <Icon className="w-3.5 h-3.5" />
      </span>
      {label}
    </div>
    <div key={value} className={`font-rounded font-semibold text-3xl mt-2 tabular-nums ${fresh ? "pop-in" : ""} ${bad ? "text-[#FF6B61]" : "text-white"}`}>
      {value}<span className="text-xs font-normal text-neutral-500 ml-1">{unit}</span>
    </div>
  </div>
);
